import { Component } from '@angular/core';
import { GungFlowDetailsBasicSettingsComponent } from 'gung-standard';

@Component({
    selector: 'cult-flow-details-basic-settings',
    templateUrl: './cult-flow-details-basic-settings.component.html',
    styleUrls: ['./cult-flow-details-basic-settings.component.scss'],
    standalone: false
})
export class CultFlowDetailsBasicSettingsComponent extends GungFlowDetailsBasicSettingsComponent {}
